export default __webpack_public_path__ + "static/media/nft2.df3a96c5.png";